import { render } from "./user.vue?vue&type=template&id=b750d10c"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"

import "./user.vue?vue&type=style&index=0&id=b750d10c&lang=css"
script.render = render

export default script